export { bindConversationFrameMetadata } from "@/lib/conversation-frame-metadata-binding";

export const CONVERSATION_FRAME_WIDTH = 400;
export const CONVERSATION_FRAME_HEIGHT = 300;
